module.exports = __webpack_public_path__ + "summernote.9cd6e041544b63fb70f4.eot";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_bower/summernote/dist/font/summernote.eot?ad8d7e2d177d2473aecd9b35d16211fb
// module id = ../../../../../src/assets/vendors/by_bower/summernote/dist/font/summernote.eot?ad8d7e2d177d2473aecd9b35d16211fb
// module chunks = styles